import React,{ChangeEvent} from 'react';
import {
  FormGroup,
  Label,
  FormFeedback,
  Row,
  Col,
  Input
} from 'reactstrap';
import {FormErrors} from '../../../types/general-types'

interface GeneroProps {
    handleInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
    formErrors:FormErrors
}

const Genero = (props:GeneroProps) => {
    const {handleInputChange, formErrors} = props;
    return (
        <FormGroup>
        <Row>
          <Col md={3}>
            <Label for="gender">Género:</Label>
          </Col>
          <Col className="pt-3">
            <Input
              type="radio"
              name="gender"
              id="male"
              value="m"
              onChange={handleInputChange}
            />
            <Label for="male" className="ms-2">
              Hombre
            </Label>
          </Col>
          <Col className="pt-3">
            <Input
              type="radio"
              name="gender"
              id="female"
              value="f"
              onChange={handleInputChange}
            />
            <Label for="female" className="ms-2">
              Mujer
            </Label>
          </Col>
        </Row>
        {formErrors.gender && (
          <Row>
            <Col>
              <FormFeedback style={{ display: 'block' }}>
                {formErrors.gender}
              </FormFeedback>
            </Col>
          </Row>
        )}
      </FormGroup>
    );
};

export default Genero;